import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { RouterProvider } from "react-router-dom";
import ROUTES from './router';
import HubContextProvider from 'Redux/Provider/HubContextProvider';
import reportWebVitals from './reportWebVitals';
import '@heartlandone/vega/style/vega.css'
import { clearTokenAndRedirect } from './Chore/auth';

const urlObj = new URL(window.location.href);
const tokenFromUrl = urlObj.searchParams.get('token');
const tokenFromStorage = sessionStorage.getItem('token');

if (!tokenFromUrl && !tokenFromStorage) {
  console.log('No token found in both url and sessionStorage, redirecting...', urlObj);
  clearTokenAndRedirect();
} else {
  if (tokenFromUrl) {
    sessionStorage.setItem('token', `Bearer ${tokenFromUrl}`);
    urlObj.searchParams.delete('token');
    window.history.replaceState({}, document.title, urlObj.toString());
  }
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <HubContextProvider>
      <RouterProvider router={ROUTES} />
    </HubContextProvider>
  );
}
reportWebVitals();
